import { Card, CardBody, CardHeader } from "reactstrap";
import { useState } from "react";
import { CampoTable } from "./components/table";
import { CrearCampo } from "./components/crear";
import { EditarCampo } from "./components/editar";
import { useCampo } from "./hooks/useCampo";

export function CampoPage() {
  const { campo: campos, fetchCampos } = useCampo();
  const [selectedCampo, setSelectedCampo] = useState(null);
  const [create, setCreate] = useState(false);

  const handleOnSuccess = () => {
    setCreate(false);
    setSelectedCampo(null);
    fetchCampos();
  };

  const handleCreateNew = () => {
    setCreate(!create);
    setSelectedCampo(null);
  };

  const handleEdit = (campo) => {
    setSelectedCampo(campo);
    setCreate(false);
  };

  return (
    <Card>
      <CardHeader>Administrar campos</CardHeader>
      <CardBody>
        <button className="btn btn-outline-success" onClick={handleCreateNew}>
          Nuevo
        </button>
        <div style={{ display: "flex", flexDirection: "row" }}>
          <CampoTable
            campos={campos}
            onSelectCampo={handleEdit}
            onSuccess={handleOnSuccess}
          />
          {create && <CrearCampo onSuccess={handleOnSuccess} />}
          {selectedCampo && (
            <EditarCampo
              campo={selectedCampo}
              onCancel={() => setSelectedCampo(null)}
              onSuccess={handleOnSuccess}
            />
          )}
        </div>
      </CardBody>
    </Card>
  );
}
